<template>
  <div id="app">
    <div class="header">
      <topTitle />
    </div>
    <div class="main">
      <router-view />
    </div>
  </div>
</template>

<script>
import topTitle from "./components/topTitle.vue";
// import HelloWorld from "./components/HelloWorld.vue";

export default {
  name: "App",
  components: { topTitle },
};
</script>

<style>
body {
  margin: 0;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: 100vh;
}
.header {
  height: 100px;
}
.main {
  height: calc(100% - 100px);
}
</style>
